import { render, staticRenderFns } from "./ApprovalHistories.vue?vue&type=template&id=77e3a77a&"
import script from "./ApprovalHistories.vue?vue&type=script&lang=js&"
export * from "./ApprovalHistories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports